

import React, { useState, useEffect } from "react";
import imgNoData from "../../../assets/theme/empty-state-no-data.svg";
import { apiList, apiGetMedia } from "../../../services/User/media";
import { getMimeTypeByFormat, fileTypes } from "./mediaUtils";
import DocumentItem from "./DocumentItem";
import moment from "moment";
import "moment/locale/es";

export default function UserMedia() {
    const [media, setMedia] = useState([]);
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(false);
    const [downloadingId, setDownloadingId] = useState(null);

    useEffect(() => {
        getMediaData();
    }, []);

    const getMediaData = () => {
        setLoading(true);
        apiList({ limit: 50, offset: 0 })
            .then(resp => {
                const temp = resp.data.map((file, key) => ({
                    ...file,
                    type: fileTypes.find(ft => ft.value === file.type)?.label || file.type,
                    created_at: moment.unix(file.created_at).locale('es').format('D MMM, YYYY')
                }));
                setMedia(temp);
                setNoData(temp.length === 0);
                setLoading(false);
            }).catch(err => {
                setNoData(true);
                setLoading(false);
            });
    };

    const handleDownload = async (file) => {
        if (file?.path) {
            const resp = await apiGetMedia(file.path);
            const base64Content = resp.data?.content;
            const format = resp.data?.format || file.format;
            if (base64Content) {
                const filename = file.text || file.url || `archivo.${format || "pdf"}`;
                const mimeType = getMimeTypeByFormat(format);
                const link = document.createElement("a");
                link.href = `data:${mimeType};base64,${base64Content}`;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };

    if (loading) return null;

    return (
        <div className="col-lg-9">
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <h5 className="card-header-title">
                        Documentación
                    </h5>
                </div>
                <div className="card-body">
                    <div>
                        <ul className="list-unstyled mb-5">
                            <li className="card card-bordered shadow-none mb-3">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-6 col-md mb-3 mb-md-0">
                                            <small className="card-subtitle mb-0">Descripción</small>
                                        </div>
                                        <div className="col-6 col-md">
                                            <small className="card-subtitle mb-0">Tipo</small>
                                        </div>
                                        <div className="col-6 col-md">
                                            <small className="card-subtitle mb-0">Fecha de carga</small>
                                        </div>
                                        <div className="col-6 col-md mb-3 mb-md-0">
                                            <small className="card-subtitle mb-0">Documento</small>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            {noData && (
                                <div className="text-center content-space-1">
                                    <br/><br/>
                                    <img src={imgNoData} className="avatar avatar-xl mb-3" alt="Documentos"/>
                                    <p className="card-text">No hay documentación para mostrar</p>
                                    <br/><br/>
                                </div>
                            )}
                            {media.map((doc, key) => (
                                <li key={key} className="card card-bordered shadow-none mb-3">
                                    <DocumentItem doc={{...doc, downloading: downloadingId === doc.id}} onDownload={handleDownload} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
